// @flow

import typeToReducer from 'type-to-reducer'

import type { Limits } from '@alphaott/api-client/types/limits'

import { GET_MOVIE_LIMITS, RESET_MOVIE_LIMITS } from '../../actions/limits'

export type MovieLimitState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Limits | {},
}

const initialState: MovieLimitState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: {},
}

const movieLimits = typeToReducer(
  {
    [GET_MOVIE_LIMITS]: {
      LOADING: (state): MovieLimitState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): MovieLimitState => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload.data,
      }),

      ERROR: (state, action): MovieLimitState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
      }),
    },
    [RESET_MOVIE_LIMITS]: () => initialState,
  },
  initialState,
)

export { movieLimits }
